import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";
import QParamList from "@quest_editor/components/QParamList";

const SurveySection = ({
  surveyPreInstruction,
  qParam1Text,
  qParam2Text,
  qParam3Text,
  surveyId,
}: {
  surveyPreInstruction: string | null;
  qParam1Text: string | null;
  qParam2Text: string | null;
  qParam3Text: string | null;
  surveyId: string | null;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.survey")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit/survey"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.survey.pre_instruction"),
          children: (
            <Typography color="text.secondary">
              {surveyPreInstruction ?? ""}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.survey.q_param"),
          children: (
            <Stack direction="column" spacing={1}>
              <QParamList
                childrenList={{
                  qParam1: (
                    <Typography color="text.secondary">
                      {qParam1Text ?? ""}
                    </Typography>
                  ),
                  qParam2: (
                    <Typography color="text.secondary">
                      {qParam2Text ?? ""}
                    </Typography>
                  ),
                  qParam3: (
                    <Typography color="text.secondary">
                      {qParam3Text ?? ""}
                    </Typography>
                  ),
                }}
              />
            </Stack>
          ),
        },
        {
          label: t("quest_detail.field.survey.content"),
          children: (
            <SubActionButton
              size="small"
              component={Link}
              to={`/quest_editor/survey/${surveyId}/preview`}
            >
              {t("quest_detail.button.goto_survey_preview")}
            </SubActionButton>
          ),
        },
      ]}
    />
  );
};

export default SurveySection;
